import { render, staticRenderFns } from "./EcoInfoList.vue?vue&type=template&id=44a2979a&"
import script from "./EcoInfoList.vue?vue&type=script&lang=js&"
export * from "./EcoInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports